import styled from 'styled-components/native';
import { TAB_SCREEN_WIDTH } from '~/data/constants';

export const CONTAINER_WIDTH = TAB_SCREEN_WIDTH;
export const ICON_CARD_WIDTH = 80;

export const Container = styled.View`
  padding-vertical: 24px;
`;
